/**
 * Whether the screen on show has edits it hasn't saved. A screen that keeps
 * edits (the review screen) says so here, next to its `beforeunload` prompt, so
 * that something moving the person elsewhere from outside the screen (the
 * welcome tour) can ask first, as the screen's own buttons do.
 */

let unsaved = false;

export function setUnsaved(value: boolean) {
  unsaved = value;
}

export function hasUnsaved(): boolean {
  return unsaved;
}
